import React, { Component } from "react";
import styled from 'styled-components';
import { resetMessage } from "../actions/reset";
import { message } from 'antd';
import { connect } from "react-redux";
const Msg = styled.div`
  position: fixed;
  right: 100px;
  top:0px;
  width: 400px;
  z-index: 10000000;
    animation: mymove 1s  ;

  @keyframes mymove {
   0%{top: -100px}
  
   
   100%{top: 0px}
}
`;

class MessageAlert extends Component {
  state = {
    show: false,
    message: null,
  };
  handleShow = () => {
    this.setState({ show: !this.state.show });
  };
  componentDidMount() {
   
    setTimeout( () =>{ this.props.resetMessage()}, 5000);
  } 
  onClose = (e) => {
    console.log(e, 'I was closed.');
  };
 
  render() {
    const { type } = this.props;
    return (
      <Msg>
       
    {type === 'error' ? message.error(this.props.value) : message.success(this.props.value)}
         
      </Msg>
    );
  }
}

export default connect(null, { resetMessage })(MessageAlert);
